// Mirror of the backend utils/dueCancellation.js: dues dated after a contract's
// closeDate are flagged with this status on close. They stay visible as
// "Cancelado" but are no longer owed (no payments, not in unpaid totals).
export const DUE_CANCELLED_BY_CLOSE = 'cancelado por contrato finalizado';

export const isCancelledByClose = (due) => due?.status === DUE_CANCELLED_BY_CLOSE;
